import { createReducer, createActions } from "reduxsauce";
import aDate from "../util/aDate";
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
	setSiderStatus: ["siderStatus"],
	setPreviewTheme: ["theme"],
	setReportDate: ["reportDate"],
	setTheme: ["theme"],
	clearPreviewTheme: null,
	clearTemporary:null
});

export const UserTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	siderStatus: false,
	reportDate: {
		primary: aDate.getAllTimeDateRange(),
		secondary: null
	},
	previewTheme: {}
};

/* ------------- Reducers ------------- */

// request the data from an api
export const setSiderStatus = (state, { siderStatus }) => (
	Object.assign({}, state, { siderStatus })
);
export const setReportDate = (state, { reportDate })=>(
	Object.assign({}, state, { reportDate })
);
export const setPreviewTheme = (state, {theme})=>(
	Object.assign({},state, { previewTheme: theme })
);
export const clearPreviewTheme = (state)=>(
	Object.assign({},state, { previewTheme:{} })
);
export const clearTemporary = (state)=>(
	Object.assign({},state, {
		previewTheme:{},
		reportDate: {
			primary: aDate.getAllTimeDateRange(),
			secondary: null
		}
	})
);
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.SET_SIDER_STATUS]: setSiderStatus,
	[Types.SET_PREVIEW_THEME]: setPreviewTheme,
	[Types.SET_REPORT_DATE]: setReportDate,
	[Types.CLEAR_PREVIEW_THEME]: clearPreviewTheme,
	[Types.CLEAR_TEMPORARY]: clearTemporary
});



// WEBPACK FOOTER //
// ./src/reducers/SettingReducer.js